import React from 'react';

const TagPreview = ({ text, textColor, color }) => {
  return (
    <div className="border-2 border-dashed border-gray-300 dark:border-slate-600 rounded-md p-6 bg-gradient-to-br from-gray-50 to-gray-100 dark:from-slate-700 dark:to-slate-800">
      <label className="block text-sm font-medium text-gray-700 dark:text-slate-400 mb-4">
        Live Preview
      </label>
      <div className="flex items-center justify-center py-6">
        {text ? (
          <span
            className="inline-flex items-center rounded-full px-4 py-1 text-lg font-medium shadow-sm transition-all duration-200 hover:scale-105"
            style={{
              backgroundColor: color,
              color: textColor,
            }}
          >
            {text}
          </span>
        ) : (
          <span
            className="inline-flex items-center rounded-full px-4 py-1 text-lg font-medium opacity-60 shadow-sm"
            style={{
              backgroundColor: color,
              color: textColor,
            }}
          >
            Sample Tag
          </span>
        )}
      </div>
      <div className="text-center">
        <p className="text-sm text-gray-500 dark:text-slate-400 font-medium">
          This is how your tag will appear
        </p>
      </div>
    </div>
  );
};

export default TagPreview;
